import Box from "@/components/Box";
import CustomerPage from "@/components/CustomerPage";
import { theme } from "@/core/theme";
import B2CHeader from "@/tpo/header/B2CHeader";

export default function PatientPayStatusPage({ title, children, action }) {
  return (
    <>
      <B2CHeader />
      <CustomerPage
        bg="haze"
        jumbotronProps={{
          title,
          bg: "purple",
          color: "white"
        }}
      >
        <Box pt={theme.spacing.section.pt} pb={theme.spacing.section.pb} px={20}>
          <Box maxWidth={760} mx="auto" width="100%">
            <Box fontFamily="gilroyMedium" fontSize={[14, 14, 16]} textAlign="left">
              {children}
            </Box>
            {action ? (
              <Box mt={40} display="flex" justifyContent="center">
                {action}
              </Box>
            ) : null}
          </Box>
        </Box>
      </CustomerPage>
    </>
  );
}
